import React from 'react';
import { Link } from 'react-router-dom';

const Projects: React.FC = () => {
  return (
    <div className="container-fluid projects bg-light py-5">
      <div className="container py-5">
        <div className="section-title position-relative text-center mx-auto mb-5 pb-4 wow fadeInUp"
          data-wow-delay="0.1s" style={{ maxWidth: "800px" }}>
          <h1 className="display-4 mb-4">Our Comprehensive Water Treatment Services</h1>
          <p className="mb-1">We offer a full spectrum of specialized solutions—from plant design and chemical
            treatments to operation, maintenance, and wastewater management—tailored to meet your industry's
            unique water challenges.</p>
        </div>
        <div className="row g-5 mb-5">
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-pane fade show p-0 active">
              <div className="projects-item">
                <img src="img/wtp_ro.jpg" className="img-fluid w-100" alt="" />
                <div className="projects-content bg-white p-4">
                  <h4 className="mb-3">Water Treatment Plants </h4>
                  <p className="mb-4">Wasser Technochem (I) Ltd. offers advanced Water Treatment Plants
                    designed to purify raw water for industrial and municipal use. Our solutions ensure
                    high-quality, efficient, and sustainable water treatment tailored to specific
                    application needs</p>
                  <Link className="btn btn-primary py-2 px-4" to="/water-treatment-plants">Read More</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-pane fade show p-0 active">
              <div className="projects-item">
                <img src="img/industrial-4.jpg" className="img-fluid w-100" alt="" />
                <div className="projects-content bg-white p-4">
                  <h4 className="mb-3">SANYOL® WT Specialty Chemicals</h4>
                  <p className="mb-4">We provide end-to-end solutions for Chemical & Process Plants, including
                    the design, supply, and erection of reactors, blenders, piping, and utility systems.
                    Our services ensure efficient, safe, and reliable plant setup tailored to your
                    process requirements.
                  </p>
                  <Link className="btn btn-primary py-2 px-4" to="/sanyol-wt-specility-chemicals">Read More</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-pane fade show p-0 active">
              <div className="projects-item">
                <img src="img/eandc.jpg" className="img-fluid w-100" alt="" />
                <div className="projects-content bg-white p-4">
                  <h4 className="mb-3">Design & Engineering Consultancy</h4>
                  <p className="mb-4">We offer expert Design & Engineering Consultancy services, delivering
                    innovative, efficient, and customized solutions for water treatment and process
                    plants. Our team ensures optimized designs that meet technical, regulatory, and
                    operational requirements.
                  </p>
                  <Link className="btn btn-primary py-2 px-4" to="/design-and-consultancy">Read More</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-pane fade show p-0 active">
              <div className="projects-item">
                <img src="img/operationandmaintainance.jpg" className="img-fluid w-100" alt="" />
                <div className="projects-content bg-white p-4">
                  <h4 className="mb-3">Operation & Maintenance</h4>
                  <p className="mb-4">We provide comprehensive Operation & Maintenance services to ensure
                    optimal performance, reliability,
                    and longevity of water treatment and process plants. Our proactive approach
                    minimizes downtime, reduces costs, and
                    keeps systems running efficiently and compliantly.
                  </p>
                  <Link className="btn btn-primary py-2 px-4" to="/operation-and-maintenance">Read More</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-pane fade show p-0 active">
              <div className="projects-item">
                <img src="img/revamping.jpg" className="img-fluid w-100" alt="" />
                <div className="projects-content bg-white p-4">
                  <h4 className="mb-3">Revamping of Water Treatment Plants</h4>
                  <p className="mb-4">We specialize in revamping existing water treatment plants to enhance
                    efficiency, upgrade technology,
                    and ensure compliance with current standards—extending plant life and improving
                    water quality while reducing
                    operational costs and environmental impact.
                  </p>
                  <Link className="btn btn-primary py-2 px-4" to="/revamping-of-water-treatment-plants">Read More</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-pane fade show p-0 active">
              <div className="projects-item">
                <img src="img/waster_water_solutions.jpg" className="img-fluid w-100" alt="" />
                <div className="projects-content bg-white p-4">
                  <h4 className="mb-3">Wastewater Treatment solutions</h4>
                  <p className="mb-4">We deliver efficient wastewater treatment solutions that help industries
                    and municipalities treat, recycle, and safely discharge water. Our systems ensure compliance with
                    environmental standards while promoting sustainability and resource recovery.
                  </p>
                  <Link className="btn btn-primary py-2 px-4" to="/wastewater-treatment-solutions">Read More</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
